<script>
    import { GoogleAuthProvider, signOut } from "firebase/auth";
    import { userHasPremium, userLoggedIn } from "./Stores";
    import { addDoc, collection, onSnapshot } from "firebase/firestore";
    import { getFunctions, httpsCallable } from "firebase/functions";

    export let auth;
    export let firestore;
    export let firebaseApp;

    let isOpen = false;

    let toggleMenu = () => (isOpen = !isOpen);

    const googleProvider = new GoogleAuthProvider();

    async function subToPremium() {
        const docRef = await addDoc(
            collection(
                firestore,
                "users",
                auth.currentUser.uid,
                "checkout_sessions",
            ),
            {
                price: "price_1OfmFZLOSVxOnPUQjC5FeGCM",
                success_url: window.location.origin,
                cancel_url: window.location.origin,
                allow_promotion_codes: true,
            },
        );
        onSnapshot(docRef, (snap) => {
            const { error, url } = snap.data();
            if (error) {
                // Show an error to your customer and
                // inspect your Cloud Function logs in the Firebase console.
                alert(`An error occured: ${error.message}`);
            }
            if (url) {
                // We have a Stripe Checkout URL, let's redirect.
                window.location.assign(url);
            }
        });
    }

    async function manageSubscription() {
        const functionRef = httpsCallable(
            getFunctions(firebaseApp, "us-central1"),
            "ext-firestore-stripe-payments-createPortalLink",
        );
        const { data } = await functionRef({
            returnUrl: window.location.origin,
            locale: "auto", // Optional, defaults to "auto"
        });
        window.location.assign(data.url);
    }
</script>

<div id="hamburger-menu">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div id="hamburger-icon" cy_data="hamburger-icon" on:click={toggleMenu}>
        <div id="bar1" />
        <div id="bar2" />
        <div id="bar3" />
    </div>

    {#if isOpen}
        <div id="menu-options">
            <a href="/"> 🏠 Início </a>
            <a href="/data-visualizations"> 📈 Visualizações de Dados</a>
            {#if !$userLoggedIn}
                <a href="/login" cy_data="login"> ➡️ Login </a>
            {:else}
                {#if !$userHasPremium}
                    <button on:click={subToPremium}>
                        🤩 Subscrever ao Premium
                    </button>
                {:else}
                    <!-- <button on:click={manageSubscription}>
                        👩‍⚕️ Gerir subscrição
                    </button> -->
                {/if}
                <button
                    id="logout"
                    cy_data="logout"
                    on:click={() => signOut(auth)}
                >
                    ⬅️ Logout
                </button>
            {/if}
        </div>
    {/if}
</div>

<style>
    div {
        font-size: small;
    }

    #hamburger-menu {
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: end;
    }

    #hamburger-icon {
        display: block;
        position: relative;
        cursor: pointer;
    }

    #bar1,
    #bar2,
    #bar3 {
        width: 30px;
        height: 3px;
        background: #333;
        margin: 6px 0;
    }

    #menu-options {
        display: flex;
        flex-direction: column;
        align-items: end;
        text-align: end;
        position: relative;
        line-height: 1.7rem;
    }

    button,
    a {
        margin-top: 1;
        transition: transform 0.2s;
    }

    button:hover,
    a:hover {
        transform: translateX(-0.2rem);
    }

    @media (min-width: 640px) {
        div {
            font-size: medium;
        }
    }

    @media (max-width: 320px) {
        #hamburger-menu {
            align-items: start;
        }

        #menu-options {
            align-items: start;
        }
    }
</style>
